/**
 * STEP-2 mobile sticky-footer primary action — a tiny PURE state machine that
 * guides the customer along the Photos › Configure › Cart flow before
 * offering the step-level Continue:
 *
 *   Photos tab, ≥1 photo selected      → "Configure N photos →" (switch tab)
 *   Configure tab, order has prints    → "View order (N) →"     (switch tab)
 *   anywhere else (incl. the Cart tab) → the existing Continue, unchanged —
 *     attention ! badge, review dialog and fine-art border gate all keep
 *     firing from there.
 *
 * Unit-tested in mobileCta.test.ts; the screen maps the returned kind onto
 * real handlers. Desktop never calls this.
 */

import type { SpTab } from './MobileTabs';

export interface MobileCtaInput {
  /** Active mobile tab. */
  tab: SpTab;
  /** READY photos currently selected on the Photos tab. */
  selectedCount: number;
  /** Priced prints in the order (same count as the Cart pill badge). */
  cartCount: number;
  /** True when ANY print line exists — even blocked ones the cart resolves. */
  hasPrints: boolean;
}

export type MobileCta =
  | { kind: 'to-configure'; label: string }
  | { kind: 'to-cart'; label: string }
  | { kind: 'continue' };

export function mobileFooterCta({
  tab,
  selectedCount,
  cartCount,
  hasPrints,
}: MobileCtaInput): MobileCta {
  if (tab === 'photos' && selectedCount > 0) {
    return {
      kind: 'to-configure',
      label: `Customise ${selectedCount} photo${selectedCount === 1 ? '' : 's'} →`,
    };
  }
  if (tab === 'configure' && hasPrints) {
    // Blocked-only orders price to 0 — offer the cart without a "(0)".
    return {
      kind: 'to-cart',
      label: `View order${cartCount > 0 ? ` (${cartCount})` : ''} →`,
    };
  }
  return { kind: 'continue' };
}
